<template>
  <!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
  <svg
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    :width="68"
    :height="50"
    viewBox="0 0 427.1 427.1"
    style="enable-background:new 0 0 427.1 427.1;"
    xml:space="preserve"
  >
    <g>
      <g>
        <path
          d="M93.55,156.5c-31.5,0-57,25.5-57,57s25.5,57,57,57s57-25.5,57-57C150.45,182.1,124.95,156.6,93.55,156.5z M93.55,250.5
			c-20.4,0-37-16.5-37-37c0-20.4,16.5-37,37-37c20.4,0,37,16.5,37,37C130.45,233.9,113.95,250.4,93.55,250.5z"
        />
      </g>
    </g>
    <g>
      <g>
        <path d="M380.55,172.5h-203.5c-5.5,0-10,4.5-10,10s4.5,10,10,10h203.5c5.5,0,10-4.5,10-10S386.05,172.5,380.55,172.5z" />
      </g>
    </g>
    <g>
      <g>
        <path d="M286.65,234.5h-109.6c-5.5,0-10,4.5-10,10s4.4,10,10,10h109.6c5.5,0,10-4.5,10-10S292.15,234.5,286.65,234.5z" />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M93.55,0c-31.5,0-57,25.5-57,57s25.5,57,57,57s57-25.5,57-57C150.45,25.5,124.95,0,93.55,0z M93.55,93.9
			c-20.4,0-37-16.5-37-37s16.5-37,37-37c20.4,0,37,16.5,37,37C130.45,77.4,113.95,93.9,93.55,93.9z"
        />
      </g>
    </g>
    <g>
      <g>
        <path d="M380.55,15.5h-203.5c-5.5,0-10,4.5-10,10s4.5,10,10,10h203.5c5.5,0,10-4.5,10-10S386.05,15.5,380.55,15.5z" />
      </g>
    </g>
    <g>
      <g>
        <path d="M286.65,78.5h-109.6c-5.5,0-10,4.5-10,10s4.4,10,10,10h109.6c5.5,0,10-4.5,10-10S292.15,78.5,286.65,78.5z" />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M93.55,313.1c-31.5,0-57,25.5-57,57s25.5,57,57,57s57-25.5,57-57C150.45,338.6,124.95,313.1,93.55,313.1z M93.55,407
			c-20.4,0-37-16.5-37-37c0-20.4,16.5-37,37-37c20.4,0,37,16.5,37,37C130.45,390.5,113.95,407,93.55,407z"
        />
      </g>
    </g>
    <g>
      <g>
        <path d="M380.55,328.5h-203.5c-5.5,0-10,4.5-10,10s4.5,10,10,10h203.5c5.5,0,10-4.5,10-10S386.05,328.5,380.55,328.5z" />
      </g>
    </g>
    <g>
      <g>
        <path d="M286.65,391.5h-109.6c-5.5,0-10,4.5-10,10s4.5,10,10,10h109.6c5.5,0,10-4.5,10-10S292.15,391.5,286.65,391.5z" />
      </g>
    </g>
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#3B334A',
    },
    size: {
      type: Number,
      default: 12,
    },
  },
};
</script>
